import styled from 'styled-components/macro';

export const Timer = styled.div`
  font-family: Lato;
  font-size: 10px;
  color: '#7b7b85';
  margin-top: 5px;
`;

export const LoadingBar = styled.div`
  background: transparent;
  position: absolute;
  width: 100%;
  height: 5px;
  left: 0;
  bottom: 0;

  &::before {
    content: '';
    background: ${(props) => (!props.isSelectedTicket ? '#0098c7' : '#93e6ff')};
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    bottom: 0;
    transform: ${(props) => `translateX(${props.percent}%)`};
    transition: transform 1s linear;
    animation: ${(props) => props.percent > -20 && 'blink 1s infinite'};
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 1;
    }
  }
`;

export const ChatTabBarBackground = styled.div`
  margin: 0px;
  padding: 0px;
  height: 2px;
  background-color: ${(props) => (props.isSelectedTicket ? '#D3DAE7' : '#6E7C93')};
`;

export const ChatTabBar = styled.div`
  margin: 0px;
  padding: 0px;
  height: 2px;
  background-color: ${(props) => (props.isSelectedTicket ? '#495671' : '#BECAE2')};
  width: ${(props) => `${100 + props.percent}%`};
`;

export const ChatTabLabel = styled.p`
  font-size: 8px;
  line-height: 9px;
  margin-top: 3px !important;
  color: ${(props) => (props.isSelectedTicket ? '#495671' : '#A6B0C5')};
`;
